// extracted by mini-css-extract-plugin
export default {"confirmAndPayButton":"UpdateToAnnuallyButton_confirmAndPayButton__gbd66"};